import { createTheme } from "@material-ui/core/styles";

const outerTheme = createTheme({
	typography: {
		allVariants: {
			fontFamily: "Tahoma",
		}
	},
	palette: {
		primary: {
			main: "#00b6db",
			contrastText: "#fff" // new logo the gray background 
		},
		secondary: {
			main: "#429fca",
			contrastText: "#fff" // new logo the gray background 

		},
	},
	overrides: {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		MuiButton: {

			root: {
				textTransform: "none",

			},
		},
		MuiTab: {
			root: {
				textTransform: "none",
			}
		},
		MuiCard: {
			root: {
				overflow: "initial"
			}
		}
	},
	props: {
		MuiButton: {
			disableElevation: true
		},
		MuiTable: {

		}
	}
});

export default outerTheme;
